const toLower = (value) => String(value || "").trim().toLowerCase();

const appendIfPresent = (params, key, value) => {
  if (value !== null && value !== undefined && String(value).trim() !== "") {
    params.set(key, String(value).trim());
  }
};

export const isTicketNotification = (notification) => {
  const referenceType = toLower(notification?.reference_type);
  if (referenceType === "ticket" || referenceType === "v2_ticket") return true;

  const title = toLower(notification?.title);
  const message = toLower(notification?.message || notification?.content || notification?.body);
  const type = toLower(notification?.type || notification?.ticket_type);

  return title.includes("ticket") || message.includes("ticket") || type.includes("ticket");
};

const isTicketStatusUpdated = (notification) => {
  const type = toLower(notification?.type || notification?.ticket_type);
  const title = toLower(notification?.title);
  const message = toLower(notification?.message || notification?.content || notification?.body);

  return (
    type === "ticket_status_updated" ||
    title.includes("ticket status updated") ||
    (title.includes("status updated") && title.includes("ticket")) ||
    message.includes("has been resolved")
  );
};

// Single source of truth for "where does a ticket notification navigate to."
// v2 tickets (the Tickets table, created via /api/ticket/v2) go straight to
// their detail page. Anything else falls back to the tickets list with the
// query params the old system used for its scroll-to-highlight behaviour —
// that list no longer reads them (TicketsV2 replaced it), but keeping them
// is harmless and avoids losing information for any other consumer.
export const buildTicketNotificationOpenUrl = (notification) => {
  const referenceType = toLower(notification?.reference_type);

  const ticketId =
    notification?.ticket_id ??
    notification?.ticketId ??
    (referenceType === "ticket" || referenceType === "v2_ticket"
      ? notification?.reference_id ?? notification?.referenceId
      : null);

  if (referenceType === "v2_ticket" && ticketId) {
    return `/tickets/${ticketId}`;
  }

  const referenceId = notification?.reference_id ?? notification?.referenceId;
  const scrollTarget = ticketId || referenceId;

  const params = new URLSearchParams();
  appendIfPresent(params, "notification_id", notification?.id);
  appendIfPresent(params, "ticket_id", ticketId);
  appendIfPresent(params, "reference_id", referenceId);
  appendIfPresent(params, "scrollTo", scrollTarget);
  appendIfPresent(params, "type", notification?.type);
  appendIfPresent(params, "ticket_type", notification?.ticket_type);
  appendIfPresent(params, "reference_type", notification?.reference_type);
  if (isTicketStatusUpdated(notification)) params.set("open_tab", "created");

  const query = params.toString();
  return query ? `/tickets?${query}` : "/tickets";
};
